import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=76a9877b"
import script from "./AdminList.js?vue&type=script&lang=js&external"
export * from "./AdminList.js?vue&type=script&lang=js&external"
import style0 from "./AdminList.vue?vue&type=style&index=0&id=76a9877b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports